export const ProgramWeekMealPlan = {
  bindings: {
    completions: '<',
    isLoading: '<',
    mealPlanId: '<',
    mealPlanList: '<',
    onCardClick: '&',
    onCompleterToggle: '&',
    program: '<',
    weekNumber: '<',
  },

  template: `
    <div class="container program-week-meal-plan">
      <section class="section-carousel carousel-mealplan">
        <h4>
          <span class="aside">Week {{ $ctrl.weekNumber }}</span> Meal Plan
          <a class="btn btn-pill btn-sm theme-btn px-2 ml-2 font-weight-semibold float-right float-sm-none"
            ui-sref="program.week.mealPlan({ mealPlanId: $ctrl.mealPlanId })">
            View and Edit
          </a>
        </h4>
        <carousel
          list="$ctrl.mealPlanList"
          is-loading="$ctrl.isLoading">
          <div class="carousel-slide-wrapper"
            ng-class="item.mealsInGroup > 0 ? 'carousel-slide-group carousel-slide-group-' + item.mealsInGroup : ''"
            ng-repeat="item in $ctrl.mealPlanList track by $index">
            <div class="carousel-slide"
              ng-class="{ selected: $ctrl.program.currentWeek === $ctrl.weekNumber && $ctrl.program.currentDay === item.day }">
              <completer
                title="{{ 'Day ' + item.day }}"
                is-complete="$ctrl.completions[item.dayString]"
                on-toggle="$ctrl.onCompleterToggle({
                  mealPlanId: $ctrl.mealPlanId,
                  dayString: item.dayString,
                  voomeProductId: $ctrl.program.id,
                  weekNumber: $ctrl.weekNumber,
                  title: 'Day ' + item.day,
                  isComplete: $ctrl.completions[item.id]
                })">
              </completer>
              <card-recipe
                recipe="item.recipe"
                is-leftover="item.leftOvers"
                on-click="$ctrl.onCardClick({ recipeId: item.recipe.id })">
              </card-recipe>
            </div>
          </div>
        </carousel>
        <div class="row mt-4">
          <div class="col-md-9 text-md-left">
            <ul class="fa-ul">
              <li>
                <i class="fa-li fa icon-recipes"></i> Stick to the plan! Have no
                more than 2 snacks a day of dairy, fruit or nuts.
              </li>
            </ul>
          </div>
          <div class="col-md-3 text-center text-md-right">
            <a class="link ml-3"
              ui-sref="program.week.mealPlan.shoppingList({ mealPlanId: $ctrl.mealPlanId })">
              Shopping list
            </a>
          </div>
        </div>
      </section>
    </div>`,
};



// WEBPACK FOOTER //
// ./src/components/Program/ProgramWeekMealPlan.js